import { MainButton } from 'elements/button/MainButton';
import { DetailQuery_moment_cards_FacebookCard } from 'graphql/query/__generated__/DetailQuery';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { useEffect, useState } from 'react';
import { FacebookEmbed } from 'react-social-media-embed';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    card: DetailQuery_moment_cards_FacebookCard;
    className?: string;
}

export const FacebookCard = (props: Props): JSX.Element => {
    const [loading, setLoading] = useState(true);
    const postId = props.card.facebook.postId;
    const isWide = useIsWide();

    //For edit panel refresh
    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 50);
    }, [postId]);

    return (
        <S_FacebookCard className={props.className}>
            {!loading && <FacebookEmbed url={postId} width={isWide ? 443 : 340} />}
            <S_Link href={postId} target="_blank" rel="noreferrer">
                <MainButton
                    type="event-secondary"
                    iconSet="far"
                    iconName="arrow-up-right-from-square"
                >
                    {Localization.OPEN_FACEBOOK}
                </MainButton>
            </S_Link>
        </S_FacebookCard>
    );
};

const S_FacebookCard = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`;

const S_Link = styled.a`
    margin: 15px 0 0 0;
`;
